module.exports = __webpack_public_path__ + "media/components/assets/icons/reply_empty-5e72f532ee69293a892e6e252724aa9d.svg";